import MensajeInternoService from 'src/modules/mensajeInterno/mensajeInternoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'MENSAJEINTERNO_VIEW';

const mensajeInternoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: mensajeInternoViewActions.FIND_STARTED,
      });

      const record = await MensajeInternoService.find(id);

      dispatch({
        type: mensajeInternoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: mensajeInternoViewActions.FIND_ERROR,
      });

      getHistory().push('/mensaje-interno');
    }
  },
};

export default mensajeInternoViewActions;
